module.exports = __webpack_public_path__ + "img/avatar4.79fef36b.png";